import {register} from '@shopify/theme-sections'

import '../../styles/sections/section-custom-collection-list.scss'

export default register(`section-custom-collection-list`, {

  onLoad() {
    document.querySelectorAll(`.collection-labels > .list-collection-button`).forEach((element) => {
      element.addEventListener(`click`, (event) => {
        document.querySelector(`.list-collection-button.active`).classList.remove(`active`)
        document.querySelector(`.sub-collection-list-container.active`).classList.remove(`active`)
        event.target.classList.add(`active`)
        const targetCollection = event.target.dataset[`target`]
        document.querySelector(`[data-collection="${targetCollection}"]`).classList.add(`active`)
      })
    })
  },

  onUnload() {
  },
})
